"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var utils_1 = require("../../../utils");
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var PrizesTable = function (_a) {
    var prizes = _a.prizes;
    var t = (0, next_intl_1.useTranslations)('translation');
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var loyaltyBonuses = (0, swr_hooks_1.useLoyaltyBonuses)().data;
    var preparedPrizes = (0, utils_1.generatePrizeTable)({
        prizes: prizes || [],
        currency: currentCurrency,
        bonuses: loyaltyBonuses || [],
        startFrom: 4,
    });
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.row, " ").concat(styles_module_scss_1.default.head) },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.column }, t('position')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.column }, t('prizes'))),
        preparedPrizes.map(function (item, idx) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
            if (!item.value)
                return null;
            return (react_1.default.createElement("div", { className: styles_module_scss_1.default.row, key: "tournament_places_prizes".concat(idx) },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.column }, item.place),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.column },
                    ((_a = item.value) === null || _a === void 0 ? void 0 : _a.amount) > 0
                        ? "".concat((_b = item.value) === null || _b === void 0 ? void 0 : _b.amount, " ").concat(currentCurrency)
                        : ((_c = item.value) === null || _c === void 0 ? void 0 : _c.freeSpins)
                            ? "".concat(item.value.freeSpins, " ").concat(t('fs').toLocaleUpperCase())
                            : ((_d = item === null || item === void 0 ? void 0 : item.value) === null || _d === void 0 ? void 0 : _d.loyaltyExp)
                                ? "".concat(item.value.loyaltyExp, " ").concat(t('loyalExp').toLocaleUpperCase())
                                : ((_e = item === null || item === void 0 ? void 0 : item.value) === null || _e === void 0 ? void 0 : _e.loyaltyPoints)
                                    ? "".concat(item.value.loyaltyPoints, " ").concat(t('points').toLocaleUpperCase())
                                    : item.value.physicalReward
                                        ? item.value.physicalReward.toLocaleUpperCase()
                                        : '',
                    ((_f = item.value) === null || _f === void 0 ? void 0 : _f.bonus)
                        ? "".concat(((_g = item.value) === null || _g === void 0 ? void 0 : _g.bonus.percents) || '', " ").concat(((_j = (_h = item.value) === null || _h === void 0 ? void 0 : _h.bonus) === null || _j === void 0 ? void 0 : _j.amount) ? (_l = (_k = item.value) === null || _k === void 0 ? void 0 : _k.bonus) === null || _l === void 0 ? void 0 : _l.amount : '', " ").concat(((_o = (_m = item.value) === null || _m === void 0 ? void 0 : _m.bonus) === null || _o === void 0 ? void 0 : _o.freespins)
                            ? ((_q = (_p = item.value) === null || _p === void 0 ? void 0 : _p.bonus) === null || _q === void 0 ? void 0 : _q.amount)
                                ? '+ '
                                : '' + ((_r = item.value) === null || _r === void 0 ? void 0 : _r.bonus.freespins) + t('fs')
                            : '')
                        : '')));
        })));
};
exports.default = PrizesTable;
